"use client";

import { ContactModal } from "@/components/contact-modal";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

export const Hero = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  useEffect(() => {
    if (modalOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [modalOpen]);

  // Modal Effect
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setModalOpen(false);
    };

    if (modalOpen) window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [modalOpen]);

  return (
    <div
      id="home"
      ref={ref}
      className="relative w-full h-screen bg-[linear-gradient(to_bottom_right,#FFFFFF_0%,#E9D6EC_25%,#D3ADD9_50%,#BC85C5_75%,#6B2578_100%)] overflow-hidden"
    >
      {/* Decoration */}
      <svg
        className="absolute bottom-12 md:bottom-[100px] right-[4vw] sm:right-[25vw] md:right-[9vw] w-[140px] md:w-[226px] h-[230px] md:h-[426px]"
        viewBox="0 0 226 426"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <style>
          {`
            @keyframes heroAnimateRect {
              from {
                stroke-dashoffset: 0
              }
              to {
                stroke-dashoffset: 1304
              }
            }
          `}
        </style>
        <rect
          opacity="0.35"
          x="13"
          y="13"
          width="200"
          height="400"
          rx="100"
          stroke="#FFBD58"
          strokeWidth="25"
          style={{
            strokeDasharray: "1304",
            animation: "heroAnimateRect 2s linear reverse",
          }}
        />
      </svg>

      <svg
        className={`
          absolute right-[50vw] md:right-[40vw] w-[210px] md:w-[350px] md:h-[175px] transition-all duration-1000 delay-500
          ${inView ? "bottom-0" : "-bottom-[300px]"}  
        `}
        width="350"
        height="175"
        viewBox="0 0 350 175"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle opacity="0.35" cx="175" cy="175" r="175" fill="#FFBD58" />
      </svg>

      {/* Modal */}
      {modalOpen && <ContactModal setModalOpen={setModalOpen} />}

      {/* Content */}
      <div className="relative flex md:flex-row flex-col container mx-auto w-full h-full px-7 pt-24 lg:px-28 md:pt-16 items-center gap-26">
        {/* Left content */}
        <div
          className={`flex flex-col gap-8 col-span-1 transition-all duration-[1.5s] ease-out
            ${inView ? "translate-x-0" : "-translate-x-[200%]"}
          `}
        >
          <h1 className="text-natura-darker-1 text-4.5xl/tight sm:text-[40px]/tight lg:text-5xl/tight xl:text-6xl/tight font-serifText max-w-[440px] md:max-w-full">
            Kembalikan Senyum Indahmu untuk Tampil Lebih Percaya Diri
          </h1>
          <button
            onClick={() => setModalOpen(true)}
            className="flex w-fit rounded-full bg-natura-primary hover:bg-natura-hover active:bg-natura-pressed transition-all duration-300 items-center justify-center py-2 px-4 md:px-6 gap-2 font-nunito"
          >
            <div className="size-6 sm:size-8 relative">
              <Image
                src={"/hero/whatsapp-color.png"}
                alt="cta-icon"
                fill
                className="object-contain"
              />
            </div>
            <p className="text-white text-xs sm:text-sm md:text-base">
              KONSULTASI SEKARANG
            </p>
          </button>
        </div>
        {/* Right content */}
        <div
          className={`
            relative overflow-visible w-full h-full md:h-full mt-24 sm:mt-32 md:mt-0 transition-all duration-1000
            ${inView ? "opacity-100" : "opacity-50"}  
          `}
        >
          <Image
            src={"/hero/hero-image-hd.png"}
            alt="hero-image"
            fill
            className="object-cover"
            priority
          />
        </div>
      </div>
    </div>
  );
};
